var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoiSwimming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 30.3652 2.52856 36.4697 7.02944 40.9706C11.5303 45.4714 17.6348 48 24 48C30.3652 48 36.4697 45.4714 40.9706 40.9706C45.4714 36.4697 48 30.3652 48 24C48 17.6348 45.4714 11.5303 40.9706 7.02944C36.4697 2.52856 30.3652 0 24 0C17.6348 0 11.5303 2.52856 7.02944 7.02944C2.52856 11.5303 0 17.6348 0 24Z",
    fill: "#19456B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,6) scale(0.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8623 108.509C20.529 108.509 27.8623 115.863 42.529 115.863C57.1956 115.863 64.529 108.509 79.1956 108.509C93.8623 108.509 101.196 115.863 115.862 115.863M5.8623 86.7646C20.529 86.7646 27.8623 94.1192 42.529 94.1192C57.1956 94.1192 64.529 86.7646 79.1956 86.7646C93.8623 86.7646 101.196 94.1192 115.862 94.1192M82.8623 5.8634L44.1586 27.9274L68.1956 53.6686L42.529 64.7006M35.1956 72.0553C38.8623 75.7326 50.8155 71.2288 59.1171 68.3779C69.8253 64.7006 82.8623 68.3779 79.1956 64.7006C67.176 52.6461 64.529 49.9913 64.529 49.9913C64.529 49.9913 31.529 68.3779 35.1956 72.0553ZM95.4919 49.9913C99.542 49.9913 102.825 46.6985 102.825 42.6367C102.825 38.5748 99.542 35.282 95.4919 35.282C91.4418 35.282 88.1586 38.5748 88.1586 42.6367C88.1586 46.6985 91.4418 49.9913 95.4919 49.9913Z",
    stroke: "white",
    strokeWidth: 11.7248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiSwimming);
export default __webpack_public_path__ + "static/media/poi-swimming.b921c1db22ae300fd53fab471cdf8ead.svg";
export { ForwardRef as ReactComponent };